export { default } from './ParallaxBackground';


// WEBPACK FOOTER //
// ./src/components/ParallaxBackground/index.js